import React, {useMemo} from "react";
import {useReleaseNoteList} from "~/release-notes/hooks";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Divider,
    List,
    ListItem,
    Typography
} from "@mui/material";
import {LoadingResult} from "~/apps/core/ui/LoadingResult";
import {Markdown} from "~/release-notes/components/Markdown";
import {findScrollableNode, useBottomScrollListener} from "~/lib/useBottomScrollListener";
import {VERSION} from "~/config";


export const ReleaseNoteList = () => {
    const {data, fetchMore, loading, error, canFetchMore} = useReleaseNoteList();

    const setScrollableNode = useBottomScrollListener(() => {
        fetchMore();
    }, 50, 100, false);

    const handleRef = (node) => {
        setScrollableNode(findScrollableNode(node));
    }

    const releaseNotesList = useMemo(() => {
        if (!data) {
            return null;
        }

        return data.filter(releaseNote => {
            const currentNoteVersion = parseInt(releaseNote.version.match(/^(\d+\.\d+\.\d+)/)[1].split(".").join(""));
            const latestVersion = parseInt(VERSION.match(/^(\d+\.\d+\.\d+)/)[1].split(".").join(""))
            return currentNoteVersion <= latestVersion;
        });
    }, [data])

    return (
        <div ref={handleRef}>
            <LoadingResult loading={loading} error={error != null} empty={data?.length == 0} placeholder={canFetchMore}/>
            {releaseNotesList?.length > 0 && (
                <List>
                    {releaseNotesList.map(releaseNote => (
                        <ListItem>
                            <Accordion disableGutters style={{minWidth: 0, width: "100%"}}>
                                <AccordionSummary>
                                    <Typography variant="cardTitle1" color="primary" noWrap display="block">
                                        {releaseNote.title}
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Divider/>
                                    <Typography variant="cardText" color="primary">
                                        <Markdown>
                                            {releaseNote.content}
                                        </Markdown>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                        </ListItem>
                    ))}
                </List>
            )}
        </div>
    )
}
